module.exports = "<div class=\"gw-panel-group\" ng-transclude></div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/accordion/directives/templates/accordion.html
// module id = 562
// module chunks = 0